export enum AoeQuestionAnswerType {
  DATE = "date",
  TEXT = "text",
  CODING = "coding",
  TEXT_OR_CODING = "text_or_coding",
}

export enum AoeQuestionItemControl {
  DROPDOWN = "dropdown",
  EDITABLE_DROPDOWN = "editableDropdown",
  RADIO = "radioButtons",
  MULTISELECT = "multiselect",
  TEXT = "textBox",
  CHECKBOX = "checkBox",
  DATE = "localDate",
}

export type AoeQuestionAnswerOption =
  | {
      label: string;
      valueCoding: {
        code: string;
        display: string;
      };
      valueString?: never;
    }
  | {
      label: string;
      valueString: string;
      valueCoding?: never;
    };

export interface AoeQuestion {
  question: string;
  answerType: AoeQuestionAnswerType;
  linkId: string;
  required: boolean;
  itemControl?: AoeQuestionItemControl;
  answerOptions?: AoeQuestionAnswerOption[];
}

export interface AoeQuestionnaire {
  labTestCode: string;
  questions: AoeQuestion[];
  checksum: string;
}

export interface ICD10Code {
  code: string;
  display: string;
  version: string;
}
